// frontend/src/pages/LoginPage.js

import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from '../components/LoadingSpinner';
import { useUIStore } from '../store/uiStore';

const cloudLogos = [
    { src: '/logos/aws.png', alt: 'Amazon Web Services', width: 108, height: 44 },
    { src: '/logos/azure.png', alt: 'Microsoft Azure', width: 108, height: 44 },
    { src: '/logos/gcp.png', alt: 'Google Cloud Platform', width: 108, height: 44 },
];

/**
 * @component LoginPage
 * @description Renderiza el formulario de inicio de sesión con un diseño profesional.
 */
function LoginPage() {
    const { login } = useAuth();
  const { isLoading } = useUIStore();

  return (
        <div className="relative flex min-h-screen flex-col items-center justify-center bg-[radial-gradient(circle_at_top,#F4F8FF_0%,#EDF3FF_36%,#F8FAFF_100%)] px-5 py-10">
            <div className="w-full max-w-xl rounded-[32px] border border-blue-100 bg-white/95 px-6 py-8 text-center shadow-[0_30px_100px_rgba(0,48,135,0.12)] sm:px-8 md:px-10 md:py-10">
                <div className="flex justify-center">
                    <div className="rounded-3xl border border-blue-100 bg-white px-6 py-4 shadow-sm">
                        <img
                            src="/logos/noventiq.png"
                            alt="Noventiq"
                            width="176"
                            height="48"
                            className="h-10 w-auto object-contain"
                        />
                    </div>
        </div>

                <div className="mt-8 inline-flex items-center rounded-full bg-blue-50 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-blue-600">
                    Acceso corporativo
                </div>

                <h1 className="mx-auto mt-5 max-w-lg text-3xl font-bold tracking-tight text-blue-950 md:text-4xl">
                    Gestión de Iniciativas AWS
                </h1>

                <div className="mx-auto mt-5 grid w-full max-w-[390px] grid-cols-3 place-items-center gap-3 md:max-w-[420px]">
                    {cloudLogos.map((logo) => (
                        <div
                            key={logo.alt}
                            className="flex h-14 w-full max-w-[124px] items-center justify-center rounded-2xl border border-blue-100 bg-slate-50 px-3 shadow-sm"
                        >
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                width={logo.width}
                                height={logo.height}
                                className="h-7 w-auto object-contain md:h-8"
                            />
                        </div>
                    ))}
                </div>

                <p className="mx-auto mt-4 max-w-xl text-sm leading-7 text-slate-600 md:text-base">
                    Inicia sesión con tu cuenta corporativa para continuar a la plataforma interna de seguimiento de iniciativas.
                </p>

                <button
                    type="button"
                    onClick={login}
                    className={`mt-8 inline-flex min-h-[56px] w-full items-center justify-center gap-3 rounded-2xl border border-blue-100 bg-white px-5 py-4 text-base font-semibold text-slate-900 shadow-sm transition hover:-translate-y-0.5 hover:border-blue-200 hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                        isLoading ? 'cursor-wait opacity-70' : ''
                    }`}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <>
                            <LoadingSpinner size="sm" color="text-blue-700" />
                            <span>Preparando acceso</span>
                        </>
                    ) : (
                        <>
                            <span>Iniciar sesión con</span>
                            <img
                                src="/logos/microsoft.png"
                                alt="Microsoft"
                                width="112"
                                height="24"
                                className="h-6 w-auto object-contain md:h-7"
                            />
                        </>
                    )}
                </button>

                <div className="mt-6 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-xs leading-6 text-slate-600 md:text-sm">
                    Si no puedes entrar, contacta al administrador interno para habilitar tu usuario.
                </div>
            </div>

            <p className="mt-6 text-center text-xs text-slate-500">
                &copy; {new Date().getFullYear()} Noventiq - Plataforma de Gestión de Iniciativas AWS.
            </p>
    </div>
  );
}

export default LoginPage;
